
























import {
  Component,
  Prop,
  Vue,
} from 'vue-property-decorator';
import Dialog from './Dialog.vue';
import { saveAs } from 'file-saver';
import { unparse } from 'papaparse';

@Component({
  components: { Dialog },
})
export default class ExportDialog extends Vue {
  @Prop({default: () => []}) private csvData!: any[];
  @Prop({default: () => []}) private selectedRows!: any[];
  @Prop({default: 0}) private openDialog!: number;
  @Prop({default: 0}) private itemsPerPage!: number;
  @Prop() private allDataFunc!: (maxRows: number) => Promise<any[]>;
  @Prop({default: 0}) private maxRows!: number;
  @Prop({default: null}) private columns!: string[] | null;

  private selectedRadio: number | null = null;
  private loading: boolean = false;

  private async download(csvSelection: number) {
    const downloadData = await this.getCsvData(csvSelection);
    if (!downloadData || !downloadData.length) {
      return;
    }
    // Convert to CSV
    let csv = unparse(
      downloadData,
      Object.assign(
        {
          delimiter: ',',
          encoding: 'utf-8',
          columns: this.columns,
        },
      ),
    );
    // Add UTF-8 BOM
    csv = '\ufeff' + csv;
    const blob = new Blob([csv], {
      type: 'application/csvcharset=utf-8',
    });
    // File download
    saveAs(blob, 'data.csv');
    // Close the dialog
    this.$emit('closeDialog');
  }

  private async getCsvData(csvSelection: number) {
    this.loading = true;
    try {
      if (this.csvData && this.csvData.length) {
        switch (csvSelection) {
          case 0:
            return this.csvData.filter((d: any) => this.selectedRows.map((s: any) => s.id).includes(d.id));
          case 1:
          default:
            const itemCount = this.maxRows ? Math.min(this.itemsPerPage, this.maxRows) : this.itemsPerPage;
            return itemCount < this.csvData.length ? this.csvData.slice(0, itemCount) : this.csvData;
          case 2:
            if (!this.allDataFunc) {
              return this.maxRows ? this.csvData.slice(0, this.maxRows) : this.csvData;
            } else {
              return await this.allDataFunc(this.maxRows);
            }
        }
      } else {
        return [];
      }
    } finally {
      this.loading = false;
    }
  }

  private get getAllDataLabel() {
    return this.maxRows ? `All pages / data (MAX: ${this.maxRows} rows)` : 'All pages / data';
  }
}
